export function showDesktopNotification(message) {
    if (Notification.permission === 'granted') {
        const body = _formatBody(message);
        new Notification('DomiDesk新消息提醒', {
            icon: '/icon.ico',
            ...body
        });
    } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
                showDesktopNotification(message);
            }
        });
    }
}

function _formatBody(txt) {
    let body = '';
    if(!txt) {
        return {
            body,
        }
    }
    try {
        const parsed = JSON.parse(txt);
        if(typeof parsed === 'object') {
            if(parsed.type === 'image') {
                body = '[图片]'
            }else if(parsed.type === 'file') {
                body = '[附件]' 
            }else if(parsed.type === 'txt') {
                body = parsed.txt
            }else if(parsed.type === 'SYSTEM') {
                body = '[系统消息]'
            }
        }else{
            body = parsed 
        }
    } catch (error){
        body = txt
    }
    return {
        body
    }  
}